import get from 'lodash/get';

export const DEFAULT_SERVICE_ERROR_MESSAGE = 'There was an error, please try again.';
export const DUPLICATED_SERVICE_ERROR_MESSAGE = 'A service with the same workspace, asset, port and protocol already exists.';

const normalizeMessage = (message) => {
  if (typeof message === 'string') return message.trim();
  if (Array.isArray(message)) return message.map(normalizeMessage).filter(Boolean).join(', ');
  if (message && typeof message === 'object') return Object.values(message).map(normalizeMessage).filter(Boolean).join(', ');
  return '';
};

export const getServiceErrorMessage = (error, fallback = DEFAULT_SERVICE_ERROR_MESSAGE) => {
  const status = Number(get(error, 'status', get(error, 'response.status')));
  const message = normalizeMessage(
    get(error, 'message') ||
    get(error, 'error') ||
    get(error, 'description') ||
    get(error, 'detail') ||
    get(error, 'details') ||
    get(error, 'errors') ||
    error
  );

  if (status === 409) return DUPLICATED_SERVICE_ERROR_MESSAGE;
  return message || fallback;
};
